(function () {
    window.addEventListener('load', () => {
        const $back = Array.from(document.querySelectorAll('[data-nav-back]'))
        for (const $b of $back) {
            $b.addEventListener('click', () => {
                history.back()
            })
        }
    })
})()
//Ouverture des fiches documents ayant plusieurs médias associés dans une popup
jQuery(document).ready(
    function () {
        //pour que les liens s'ouvrent dans une nouvelle fenetre
        jQuery("[id*='popup_liens_externes'] a").each(
            function (index) {
                jQuery(this).attr("target", "_blank");
            });
        //init de la popin
        jQuery('.open-document-popup').magnificPopup(
            {
                type: 'inline',
                midClick: true
            });
        //Fonction de telechargement de document pour le style de liste de documents "Consultation"
        window.initDownloadSelector = function (element) {
            //Recuperation de la valeur de l'element selectionné
            var optionValue = element.options[element.selectedIndex].value;
            //Affectation de la valeur au src du bouton de telechargement
            var links = jQuery(element).siblings("a");
            jQuery(links).attr("href", optionValue);
            //target du bouton
            if (optionValue != "#") {
                jQuery(links).attr("target", "_blank");
            } else {
                jQuery(links).attr("target", "_self");
            }
            jQuery(links).show();
            if (optionValue.indexOf("#") == 0 && optionValue.length > 1) {
                jQuery(links).filter(":not('.open-document-popup')").hide();
            } else {
                jQuery(links).filter(":not('.basicdwnldbtn')").hide();
            }
        }
    });
